import {ReactNode} from 'react';
import {Link} from 'react-router-dom';
import {ChevronRight} from 'lucide-react';

interface SettingsRowProps {
    title: string;
    description?: string;
    /** Value or control on the right. */
    trailing?: ReactNode;
    /** Makes the whole row a link with a chevron. */
    to?: string;
}

// A row inside a SettingsCard: title, one-line description and a value, control or chevron.
export const SettingsRow = ({title, description, trailing, to}: SettingsRowProps) => {
    const body = (
        <>
            <div className="min-w-0 flex-1">
                <div className="text-callout font-medium text-ink">{title}</div>
                {description && <div className="text-footnote text-ink-muted">{description}</div>}
            </div>
            {trailing && <div className="flex shrink-0 items-center">{trailing}</div>}
            {to && <ChevronRight size={16} aria-hidden="true" className="!p-0 shrink-0 !text-ink-muted"/>}
        </>
    );
    const className = 'flex min-h-14 items-center gap-4 py-2';
    return to ? <Link to={to} className={`${className} -mx-4 px-4 hover:bg-surface-muted`}>{body}</Link> : <div className={className}>{body}</div>;
};
